import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { MapPin, Calendar, AlertTriangle, Users, Shield, Fingerprint, ShieldAlert, Briefcase, Map as MapIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const visits = [{
  id: 'VST-001',
  date: '25 Mei 2026',
  location: 'Jayapura, Papua',
  purpose: 'Peresmian Stadion Lukas Enembe & Dialog Tokoh Adat',
  risk: 78,
  riskLevel: 'TINGGI',
  issues: ['Mobilisasi penolakan di grup Telegram tertutup', 'Sentimen lokal negatif 32%', 'Cuaca: hujan lebat'],
  actors: 23,
  recommendation: 'Perketat protokol VVIP, koordinasi dengan tokoh adat, tambah personel siber 2x'
}, {
  id: 'VST-002',
  date: '28 Mei 2026',
  location: 'Denpasar, Bali',
  purpose: 'Pertemuan G20 Tourism Working Group',
  risk: 42,
  riskLevel: 'SEDANG',
  issues: ['Isu pajak hiburan 75% masih panas', 'Protes komunitas pekerja seni'],
  actors: 8,
  recommendation: 'Standar pengamanan, siapkan kontra-narasi pajak hiburan'
}, {
  id: 'VST-003',
  date: '1 Jun 2026',
  location: 'Surabaya, Jawa Timur',
  purpose: 'Peresmian Pabrik Hilirisasi Tembaga',
  risk: 35,
  riskLevel: 'RENDAH',
  issues: ['Sentimen lokal mayoritas positif', 'Beberapa keluhan polusi industri'],
  actors: 4,
  recommendation: 'Standar pengamanan, dorong narasi penyerapan tenaga kerja'
}, {
  id: 'VST-004',
  date: '5 Jun 2026',
  location: 'Medan, Sumatera Utara',
  purpose: 'Kunjungan ke Sentra UMKM',
  risk: 28,
  riskLevel: 'RENDAH',
  issues: ['Isu lokal stabil'],
  actors: 2,
  recommendation: 'Standar pengamanan'
}];
const riskColor: Record<string, string> = {
  TINGGI: 'border-red-500/30 bg-red-500/5 text-red-500',
  SEDANG: 'border-amber-500/30 bg-amber-500/5 text-amber-500',
  RENDAH: 'border-emerald-500/30 bg-emerald-500/5 text-emerald-500'
};
export function VisitIntel() {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-3512">
      <PageHeader group="Ancaman & Proteksi" title="Presidential Visit Intelligence" description="Intelijen pengamanan kunjungan Presiden — risiko wilayah, aktor lokal, dan rekomendasi posture." icon={MapPin} data-id="element-3513" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3514">
        {[{
        label: 'Kunjungan Aktif',
        value: '4',
        icon: Calendar,
        color: 'text-blue-500'
      }, {
        label: 'Risiko Tinggi',
        value: '1',
        icon: AlertTriangle,
        color: 'text-red-500'
      }, {
        label: 'Aktor Lokal Terpetakan',
        value: '37',
        icon: Users,
        color: 'text-amber-500'
      }, {
        label: 'Personel Pengamanan',
        value: '420',
        icon: Shield,
        color: 'text-emerald-500'
      }].map(k => <Card key={k.label} className="bg-card border-border/50" data-id="element-3515">
            <CardContent className="p-4" data-id="element-3516">
              <div data-id="element-3517">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-3518">
                  {k.label}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.color}`} data-id="element-3519">
                  {k.value}
                </p>
              </div>
              <k.icon className={`size-6 ${k.color}`} data-id="element-3520" />
            </CardContent>
          </Card>)}
      </div>

      <div className="space-y-4" data-id="element-3521">
        {visits.map(v => <Card key={v.id} className="bg-card border-border/50" data-id="element-3522">
            <CardContent className="p-4" data-id="element-3523">
              <div className="flex items-center gap-2 mb-1" data-id="element-3524">
                <Calendar className="size-3.5 text-muted-foreground" data-id="element-3525" />
                <span className="font-mono text-xs text-muted-foreground" data-id="element-3526">
                  {v.id}
                </span>
              </div>
              <p className="font-heading text-lg font-bold" data-id="element-3527">{v.date}</p>
              <p className="text-sm text-muted-foreground flex items-center gap-1.5 mt-1" data-id="element-3528">
                <MapPin className="size-3.5" data-id="element-3529" />
                {v.location}
              </p>
              <div className={`mt-3 inline-flex items-center gap-2 px-2 py-1 rounded border font-mono text-[10px] ${riskColor[v.riskLevel]}`} data-id="element-3530">
                <AlertTriangle className="size-3" data-id="element-3531" />
                RISK SCORE: {v.risk} • {v.riskLevel}
              </div>
            </CardContent>
          </Card>)}
      </div>

      <RelatedWorkflow currentStep="Intelijen Kunjungan" nextSteps={[{
      to: '/digital-escort',
      icon: Fingerprint,
      label: 'Aktivasi Digital Escort',
      desc: 'Aktifkan pelindung siber VVIP untuk kunjungan.'
    }, {
      to: '/threat-intel',
      icon: ShieldAlert,
      label: 'Brief Threat Intel',
      desc: 'Sinkron ancaman siber & fisik di lokasi tujuan.'
    }, {
      to: '/command-tasking',
      icon: Briefcase,
      label: 'Tasking Pengamanan',
      desc: 'Delegasikan ke Paspampres & Polri setempat.'
    }, {
      to: '/geospatial',
      icon: MapIcon,
      label: 'Peta Geospasial',
      desc: 'Analisis rute & titik panas wilayah tujuan.'
    }]} data-id="element-3532" />
    </div>;
}